export default __webpack_public_path__ + "static/media/logo.320cc882.png";